<template>
  <section>

    <div class="row py-4">
      <div class="col-lg-6 offset-lg-3 col-12">
        <!-- Navigation -->
        <div class="d-flex pb-4">
          <div class="flex-fill">
            <router-link to="/rewards" class="text-primary-link">{{ $t('message.rewards.title') }}</router-link>
            <i class="fal fa-angle-right"></i>
            {{ $t('message.rewards.my_redeemed_rewards') }}
          </div>
        </div>

        <div id="content">
          <nav class="nav nav-tabs nav-justified">
            <a class="nav-item nav-link"
              :class="[(currentTab === 'isActive') ? 'active' : '']"
              href="#active"
              @click.prevent="showUserRewards('isActive')">
              {{ $t('message.rewards.tab_active_rewards') }}
            </a>
            <a class="nav-item nav-link"
              :class="[(currentTab === 'isUsed') ? 'active' : '']"
              href="#used"
              @click.prevent="showUserRewards('isUsed')">
              {{ $t('message.rewards.tab_used_rewards') }}
            </a>
            <a class="nav-item nav-link"
              :class="[(currentTab === 'isExpired') ? 'active' : '']"
              href="#expired"
              @click.prevent="showUserRewards('isExpired')">
              {{ $t('message.rewards.tab_expired_rewards') }}
            </a>
          </nav>
          <div id="my-tab-content" class="tab-content">
            <user-rewards ref="userRewards" :currentTab="currentTab"></user-rewards>
          </div>
        </div>

      </div>
    </div>
    
    
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import UserRewards from './UserRewards.vue'

  export default {
    components: {
      UserRewards
    },
    data () {
      return {
        currentTab: 'isActive'
      }
    },
    computed: {
      ...mapGetters({
        state: 'order/getState'
      })
    },
    methods: {
      showUserRewards (tab) {
        this.currentTab = tab
      }
    }
  }
</script>

<style scoped>
  .nav-tabs > a.nav-item , a.active:after {
    display: block;
    padding: 0;
    height: 4px;
    background-color: #00ACC1;
    content: ' ';
    width: 100%;
    margin: 0 auto;
    margin-top: 13px;
  }

  .nav-tabs > a.nav-item {
    background: none;
    border: 0;
    padding: 0;
  }

  .nav-tabs > a.nav-item {
    border-bottom: 1px solid #DDD;
  }

  @media (max-width: 768px) {
    .nav-justified > li {
      display: table-cell;
      width: 1%;
    }

    .nav-justified > li > a {
      border-bottom: 1px solid #DDD;
      border-radius: 0;
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/reward/UserRewardTab.vue